import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found in URL');
          alert('❌ OAuth callback failed: No session ID found');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for user data
        const response = await axios.post(
          `${API_URL}/api/auth/google/callback`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const user = response.data.user;

        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          replace: true,
          state: { user }
        });

      } catch (error) {
        console.error('Auth callback error:', error);
        const errorMsg = error.response?.data?.detail || 'Authentication failed';
        alert(`❌ Login Error: ${errorMsg}`);
        navigate('/login', { 
          replace: true,
          state: { error: errorMsg }
        });
      }
    };

    processAuth();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5]">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-4 border-[#0C9168] border-t-transparent mb-4"></div>
        <p className="text-[#52525B] text-lg">Completing sign in...</p>
      </div>
    </div>
  );
}
